import * as React from "react";
import { useEffect, useState } from "react";
import InputProps from "../../../model/form/InputProps";
import FormInput from "./FormInput";
import InputState from "../../../model/form/InputState";
import GenericInput from "./GenericInput";

const validKeys = ["0", "1", "2", "3", "4", "5", "6", "7", "8", "9", "backspace"];

interface NumberInputProps extends InputProps {
  value: Number;
}

const NumberInput = (props: NumberInputProps) => {
  const [inputValue, setInputValue] = useState(props.value.toString(10));

  useEffect(() => {
    setInputValue(props.value.toString(10));
  }, [props.value]);

  const handleKeyDown = (e: React.KeyboardEvent) => {
    if (!validKeys.includes(e.key.toLowerCase())) {
      e.preventDefault();
    }
  };

  const template = (state: InputState, input: any) => (
    <GenericInput
      type="number"
      name={props.name}
      label={props.label}
      detail={props.detail}
      additionalClass={props.additionalClass}
      status={state.status}
      placeholder={props.placeholder}
      messageLevel={props.messageLevel}
      value={inputValue}
      disabled={props.disabled}
      extraProps={{
        max: 999,
        min: 1,
        step: 1,
      }}
      onChange={(e) => {
        let val = parseInt(e.target.value, 10);
        if (isNaN(val) || val <= 0) {
          setInputValue("");
        } else if (val > 999) {
          const tooLongVal = val.toString();
          const truncatedVal = parseInt(tooLongVal.substring(0, 3), 10);
          setInputValue(truncatedVal.toString(10));
        } else {
          setInputValue(val.toString(10));
          input.change(e);
        }
      }}
      onBlur={input.dirty}
      onKeyDown={handleKeyDown}
    />
  );

  return <FormInput {...props} template={template}></FormInput>;
};

export default NumberInput;
